module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/17a svickova naporcovana 2.jpg";